'use client';

import {Container, styled} from '@mui/material';

export const StyledSectionContainer = styled(Container)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(0, 0, 6, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 5, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 0, 5, 0),
  },
}));